var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "form-page client" }, [
    _c("div", { staticClass: "container-fluid" }, [
      _c("div", { staticClass: "row justify-content-center" }, [
        _c(
          "div",
          { staticClass: "col-12 px-md-5 form-page" },
          [
            _c("page-header", {
              attrs: {
                title: _vm.$tc("documents.document", 1),
                subtitle: _vm.$t(
                  "documents.uploadDocumentsToMortgageApplication"
                ),
                size: "col-12",
                "container-class": "mb-4",
              },
            }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "card" },
              [
                _vm.loading
                  ? _c("documents-loader")
                  : _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col-12" }, [
                        _c(
                          "h5",
                          { staticClass: "grey-black bold px-sm-5 px-3 mt-4" },
                          [
                            _vm._v(
                              "\n                " +
                                _vm._s(_vm.$t("documents.requestedDocuments")) +
                                "\n                "
                            ),
                            _c("refresh-button", {
                              attrs: { loading: _vm.refreshing },
                              on: { refresh: _vm.refreshDocuments },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "p",
                          {
                            staticClass:
                              "justified grey-text text-darken-1 px-sm-5 px-3",
                          },
                          [
                            _vm._v(
                              "\n                " +
                                _vm._s(
                                  _vm.$t(
                                    "documents.requestedDocumentsDescription"
                                  )
                                ) +
                                "\n              "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "pb-5 px-sm-5 px-3" }, [
                          _c(
                            "div",
                            { attrs: { id: "accordion-pending-doc" } },
                            [
                              _vm.outstandingClassifications.length === 0
                                ? _c(
                                    "no-results",
                                    {
                                      staticClass:
                                        "d-flex flex-row align-items-center py-4",
                                      attrs: { icon: "fa-file" },
                                    },
                                    [
                                      _vm._v(
                                        "\n                    " +
                                          _vm._s(
                                            _vm.$t(
                                              "documents.thereAreNoDocumentsToShowYet"
                                            )
                                          ) +
                                          "\n                  "
                                      ),
                                    ]
                                  )
                                : _vm._l(
                                    _vm.outstandingClassifications,
                                    function (documentRequestId) {
                                      return _c(
                                        "document-classification-collapse",
                                        {
                                          key: documentRequestId,
                                          attrs: {
                                            classification:
                                              _vm.classifications.byId[
                                                documentRequestId
                                              ],
                                            documents: _vm.documents,
                                            comments: _vm.comments,
                                            "application-id": parseInt(
                                              _vm.selectedApplicationId
                                            ),
                                          },
                                        }
                                      )
                                    }
                                  ),
                            ],
                            2
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-12" }, [
                        _c(
                          "h5",
                          { staticClass: "grey-black bold px-sm-5 px-3" },
                          [
                            _vm._v(
                              "\n                " +
                                _vm._s(_vm.$t("documents.fulfilledDocuments")) +
                                "\n              "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "p",
                          {
                            staticClass:
                              "justified grey-text text-darken-1 px-sm-5 px-3",
                          },
                          [
                            _vm._v(
                              "\n                " +
                                _vm._s(
                                  _vm.$t(
                                    "documents.fulfilledDocumentsDescription"
                                  )
                                ) +
                                "\n              "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "pb-5 px-sm-5 px-3" }, [
                          _c(
                            "div",
                            { attrs: { id: "accordion-complete-doc" } },
                            [
                              _vm.completedClassifications.length === 0
                                ? _c(
                                    "no-results",
                                    {
                                      staticClass:
                                        "d-flex flex-row align-items-center py-4",
                                      attrs: { icon: "fa-file" },
                                    },
                                    [
                                      _vm._v(
                                        "\n                    " +
                                          _vm._s(
                                            _vm.$t(
                                              "documents.thereAreNoDocumentsToShowYet"
                                            )
                                          ) +
                                          "\n                  "
                                      ),
                                    ]
                                  )
                                : _vm._l(
                                    _vm.completedClassifications,
                                    function (documentRequestId) {
                                      return _c(
                                        "document-classification-collapse",
                                        {
                                          key: documentRequestId,
                                          attrs: {
                                            completed: "",
                                            classification:
                                              _vm.classifications.byId[
                                                documentRequestId
                                              ],
                                            documents: _vm.documents,
                                            comments: _vm.comments,
                                            "application-id":
                                              _vm.selectedApplicationId,
                                          },
                                        }
                                      )
                                    }
                                  ),
                            ],
                            2
                          ),
                        ]),
                      ]),
                    ]),
              ],
              1
            ),
          ],
          1
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }